export default "__VITE_ASSET__D9F7xfFZ__"